import { ConsultaMargemPayload, ConsultaMargemResultPayload, ConsultaMargemTypes } from './types'

export const marginAcceptRequest = (payload: ConsultaMargemPayload) => ({
  type: ConsultaMargemTypes.CONSULTA_MARGEM_ACCEPT_REQUEST,
  payload,
})

export const marginAcceptSuccess = () => ({
  type: ConsultaMargemTypes.CONSULTA_MARGEM_ACCEPT_SUCCESS,
})

export const marginAcceptError = () => ({
  type: ConsultaMargemTypes.CONSULTA_MARGEM_ACCEPT_ERROR,
})

export const marginResultRequest = (payload: ConsultaMargemResultPayload) => ({
  type: ConsultaMargemTypes.CONSULTA_MARGEM_RESULT_REQUEST,
  payload,
})

export const marginResultSuccess = () => ({
  type: ConsultaMargemTypes.CONSULTA_MARGEM_RESULT_SUCCESS,
})

export const marginResultError = () => ({
  type: ConsultaMargemTypes.CONSULTA_MARGEM_RESULT_ERROR,
})

export const resetMarginAcceptResult = () => ({
  type: ConsultaMargemTypes.CONSULTA_MARGEM_RESET,
})
